<template>
  <v-dialog v-model="dialog" max-width="600px" scrollable>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        x-small
        fab
        color="secondary"
        dark
        v-bind="attrs"
        v-on="on"
        @click="mostrarModal"
      >
        <v-icon dark> mdi-pencil </v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>Crear Registro</v-card-title>
      <v-card-text style="height: 100%">
        <v-overlay :value="loading" absolute>
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card-text>
            <v-form>
                <v-row>
                    <v-col cols="4">
                        <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-calculator-variant
"
                            label="Numerador"
                            :rules="fieldRules"
                            required
                            v-model="registerData.numerator"
                        />         
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-calculator-variant
"
                            label="Denominador"
                            :rules="fieldRules"
                            required
                            v-model="registerData.denominator"
                            @keyup="dividir"
                        />         
                    </v-col>
                    <v-col cols="4">
                        <v-text-field
                            outlined
                            dense
                            prepend-inner-icon="mdi-equal-box"
                            label="Resultado"
                            :rules="fieldRules"
                            required
                            v-model="registerData.result"
                        />         
                    </v-col>
                </v-row>
                <v-row>
                  <v-col
                  cols="12"
                  
                  >
                   <v-select
                  outlined
                  dense
                  :rules="fieldRules"
                  prepend-inner-icon="mdi-calendar"
                  :items="years"
                  v-model="registerData.year"
                  label="Seleccionar Año"
                />
                 <v-select
                outlined
                dense
                :rules="fieldRules"
                prepend-inner-icon="mdi-calendar"
                :items="months"
                v-model="registerData.month"
                label="Seleccionar Mes"
              />
            </v-col>
            </v-row>
        <v-textarea
                label="Observacion"
                :rules="fieldRules"
                required
                outlined
                dense
                v-model="registerData.observations"
                prepend-inner-icon="mdi-bullseye-arrow"
        ></v-textarea>   

            <list-files-register-indicators :register_indicator="register_indicator"/>
            </v-form>
          </v-card-text>
      </v-card-text>
      <v-card-actions flat>
        <v-btn @click="dialog = false" color="secondary">Cerrar</v-btn>
        <v-btn color="primary" @click="saveRegister()"
          ><v-icon left small> mdi-content-save </v-icon> Guardar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { eventBus } from "../../../main";
import { RegisterIndicatorService } from "../../../services/models/register_indicator";
import { RegisterIndicatorHistoryService } from "../../../services/models/registerIndicatorHistory";
import ListFilesRegisterIndicators from '../../filesRegisterIndicators/ListFilesRegisterIndicators.vue';
export default {
  components: { ListFilesRegisterIndicators },
  props: ["register_indicator"],
  data() {
    return {
      dialog: false,
      loading: false,
      fieldRules: [(v) => !!v || "Este campo es obligatorio"],
      date:null,
      registerData:{
        numerator:0,
        denominator:0,
        month:null,
        year:new Date().getFullYear(),
        indicator_id:this.indicator_id,
        user_id:JSON.parse(window.localStorage.getItem("user")).id,
        result:0,
        observations:null
      },
      months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],
      years:[]
    };
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    dialog(){
          if(this.dialog){
              this.loadData();
          }
      }
  },
  methods: {
    async mostrarModal() {
      this.dialog = true;
      this.loading = true;
      this.loading = false;
    },
    save (date) {
        this.$refs.menu.save(date)
      },
    dividir(){
      this.registerData.result = parseFloat(this.registerData.numerator) / parseFloat(this.registerData.denominator)
    },
   async saveRegister(){
     this.registerData={
        ...this.registerData,        
      };
      try {
        this.loading = true;
        let response = await RegisterIndicatorService.update(this.register_indicator.id,this.registerData);         
        await RegisterIndicatorHistoryService.create({...response,register_indicator_id:response.id});                
        this.showAlert({
          color: "success",
          text: "Se edito el Registro"
        });
        eventBus.$emit("clearFilesRegisterIndicatorList");
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.showAlert({
          color: "error",
          text: "Error al editar el registro"
        });
      } finally {
        this.loading = false;
        this.dialog = false;
      }
    },
    async loadData(){
        this.loading=true;
        this.years=[];
        for (let index = 2000; index < 2041; index++) {
          this.years.push(index)         
        }
        this.registerData=await RegisterIndicatorService.getById(this.register_indicator.id);        
        this.registerData.year=parseInt(this.registerData.year);
        this.loading=false;
    }
  },
};
</script>